import xss from "xss";
import { FilialeLieferadresse } from "rage_api";
import { toBooleanJN } from "../utils/functions/formatBoolean";

export default class LieferadressenStorage {
  constructor() {
    this.liste = [];
    this.timestamp = null;
    this.errorStatus = null;
    this._loading = undefined;
    this._updating = undefined;
  }

  setListe(liste) {
    if (!Array.isArray(liste)) {
      this.liste = [];
      return;
    }
    this.liste = liste.map(a => {
      // validate data
      if (!a) return null;
      const bezeichnungOnline = xss(a.bezeichnungOnline).trim();
      const bezeichnungStationaer = xss(a.bezeichnungStationaer).trim();
      const kundeVerfuegbar = !!bezeichnungOnline;
      const beraterVerfuegbar = !!bezeichnungStationaer;
      const ret = FilialeLieferadresse.constructFromObject({
        ...a,
        bezeichnungOnline,
        bezeichnungStationaer,
        edelmetallLieferbarKzBerater: beraterVerfuegbar ? a.edelmetallLieferbarKzBerater : "N",
        edelmetallLieferbarKzKunde: kundeVerfuegbar ? a.edelmetallLieferbarKzKunde : "N",
        sortenLieferbarKzBerater: beraterVerfuegbar ? a.sortenLieferbarKzBerater : "N",
        sortenLieferbarKzKunde: kundeVerfuegbar ? a.sortenLieferbarKzKunde : "N",
      });
      return { ...ret, kundeVerfuegbar, beraterVerfuegbar };
    }).filter(a => !!a);
  }

  getListe() {
    return this.liste;
  }

  updateAdresse(data) {
    if (isNaN(data.lieferadressenNummer)) return;
    this.liste = this.liste.map(a => {
      if (Number(a.lieferadressenNummer) !== Number(data.lieferadressenNummer) ||
        (!a.kundeVerfuegbar && !a.beraterVerfuegbar)
      ) return a;
      delete data.lieferadressenNummer;
      data.edelmetallLieferbarKzKunde = toBooleanJN(data.edelmetallLieferbarKzKunde);
      data.sortenLieferbarKzKunde = toBooleanJN(data.sortenLieferbarKzKunde);
      data.edelmetallLieferbarKzBerater = toBooleanJN(data.edelmetallLieferbarKzBerater);
      data.sortenLieferbarKzBerater = toBooleanJN(data.sortenLieferbarKzBerater);
      data.edelmetallMaxBetrag = isNaN(data.edelmetallMaxBetrag) ? undefined : data.edelmetallMaxBetrag;
      data.sortenMaxBetrag = isNaN(data.sortenMaxBetrag) ? undefined : data.sortenMaxBetrag;

      Object.keys(data).forEach(k => {
        if (data[k] === undefined) delete data[k];
      });
      const ret = FilialeLieferadresse.constructFromObject({ ...a, ...data });
      return { ...ret, kundeVerfuegbar: a.kundeVerfuegbar, beraterVerfuegbar: a.beraterVerfuegbar };
    });
  }

  loading(status) {
    this._loading = !!status;
  }

  isLoading() {
    return this._loading;
  }

  updating(status) {
    this._updating = !!status;
  }

  isUpdating() {
    return this._updating;
  }

  hasData() {
    return typeof this._loading === "boolean" && this._loading === false;
  }

  failed(error) {
    this.errorStatus = error;
  }

  getError() {
    return this.errorStatus ? this.errorStatus.message : "";
  }
}
